<template>
  <div id="Map" class="map">
    <l-map ref="myMap"
        :zoom="zoom"
        :maxZoom="maxZoom"
        :minZoom="minZoom"
        :bounds="bounds"
        :center="center"
        @moveend="defMaps"
        :key="key"
        style="height: 100%;top:0.8em;"
    >

        <PlaceMarker v-bind:map="map" v-if="action=='PlaceMarker'" />
        <TripMarkers v-bind:map="map" v-if="action=='TripMarkers'" />
        <TripSegms v-bind:map="map" v-if="action=='TripSegms'" />
        <UserMap v-bind:map="map" v-if="action=='UserMap'" />
        <AreaMap v-bind:map="map" v-if="areamap=='AreaMap'" />
        <ManagePlaceMarker v-bind:map="map" v-if="action=='ManagePlaceMarker'" />


    </l-map>

    <!-- <router-view></router-view> -->

  </div>

</template>

<script>
import 'leaflet/dist/leaflet.css';
require('@/assets/css/images/layers.png')
require('@/assets/css/images/marker-icon.png')
import L from 'leaflet';
import { latLng } from "leaflet";
import { LMap } from "vue2-leaflet";
import PlaceMarker from '@/components/PlaceMarker.vue'
import TripMarkers from '@/components/TripMarkers.vue'
import TripSegms from '@/components/TripSegms.vue'
import UserMap from '@/components/UserMap.vue'
import AreaMap from '@/components/AreaMap.vue'
import ManagePlaceMarker from '@/components/ManagePlaceMarker.vue'

let chsnLayer = 0;

export default {
  name: "Map",
  components: {
    LMap, //LControl,
    PlaceMarker,
    TripMarkers,
    TripSegms,
    UserMap,
    AreaMap,
    ManagePlaceMarker
  },
  data: function() {
    return {
      action: '',
      areamap: '',
      zoom: this.$store.state.curZoom,
      minZoom: 10,
      maxZoom: 18,
      center: latLng(55.75209, 37.61753),
      bounds: [],
      position: latLng(0, 0),
      map: null,
      baseLayers: L.control.layers(),
      inRu: true,
      inDon: false,
      listLoc: '',
      key: 0,
      curUserName: ''
    };
  },
  mounted() {
    this.curUserName = this.$store.state.curUserName;
    this.mount();
  },
  beforeDestroy() {
    this.$store.commit('setCurLayer', chsnLayer);
    this.$store.commit('setInRu', this.inRu);
    this.$store.commit('setCurPos', {lat: this.map.getCenter().lat, lng: this.map.getCenter().lng, zoom: this.map.getZoom() } )
    if(this.map) this.map.off();
  },
  methods: {
    mount() {
//        this.$router.go(-1);
        this.map = this.$refs.myMap.mapObject;
        this.action = this.$route.params.action;
        this.areamap = this.$route.params.areamap;
        if(!this.$yndx) this.$yandIni(this.$i18n.locale);
        this.cntlHndl();
        setTimeout( () => { this.defMaps(); }, 500 );
    },
    cntlHndl() {
      let that = this;
        this.map.on('baselayerchange', function () {
        let base = document.body.querySelectorAll('.leaflet-control-layers-selector');
        chsnLayer = 0;
        for(let i=0; i< base.length; i++) {
          if(base[i].checked) {
            chsnLayer = i;
            break;
          }
        }
        that.$store.commit('setCurLayer', chsnLayer);
        });
    },
    defMaps() {
        if(this.map) {
            // cork for return from outer url page
            try {
                this.bounds = this.map.getBounds();
            } catch(error) { this.foo="bar"; return; }
            this.baseLayers.remove();
            this.baseLayers = L.control.layers();
            if(this.inRussia()) {
                if(this.ifInDon()) this.buildDon();
                else this.buildRu();
            }
            else {
                this.buildWld();
            }
            this.$store.commit('setCurPos', {lat: this.map.getCenter().lat, lng: this.map.getCenter().lng, zoom: this.map.getZoom() } );

            let controlElements = document.body.querySelectorAll('.leaflet-control-layers-selector');

            if(this.$store.state.inRu === 0) controlElements[0].click();
            else if( (this.inRu && !this.$store.state.inRu) || (!this.inRu && this.$store.state.inRu) ) controlElements[0].click();
            else if(controlElements[this.$store.state.curLayer]) controlElements[this.$store.state.curLayer].click();
            else controlElements[0].click();

            this.$store.commit('setInRu', this.inRu);

        }
    },
    inRussia() {
        this.inRu = this.bounds.intersects( [[41.1, 19.2], [81.5, 170.0]] );
        this.inDon = false;
        return this.inRu;
    },
    ifInDon() {
        this.inDon = this.bounds.intersects( [[42.1, 30], [52, 42]] );
        if(this.inDon) this.inRu = true;
        return this.inDon;
    },
    buildRu() {
        if(!this.$yndx) this.$yandIni(this.$i18n.locale);
        if(this.curUserName) {
            this.baseLayers.addBaseLayer(this.$mapTiler, 'mapTiler');
            this.baseLayers.addBaseLayer(this.$mapbox, 'mapbox');
            this.baseLayers.addBaseLayer(this.$carto, 'carto');
            //this.baseLayers.addBaseLayer(this.$gis, '2Gis');
        }
		this.baseLayers.addBaseLayer(this.$yndx, 'yandex');
		this.baseLayers.addTo(this.map);
    },
    buildWld() {
//        if(!this.$yndx) this.$yandIni(this.$i18n.locale);

        this.baseLayers.addBaseLayer(this.$osm1, 'osm1');
        this.baseLayers.addBaseLayer(this.$osm2, 'osm2');
		this.baseLayers.addBaseLayer(this.$mapTiler, 'mapTiler');
		this.baseLayers.addBaseLayer(this.$mapbox, 'mapbox');
		this.baseLayers.addBaseLayer(this.$carto, 'carto');

//		this.baseLayers.addBaseLayer(this.$yndx, 'yandex');
		this.baseLayers.addTo(this.map);
    },
    buildDon() {
        if(!this.$yndx) this.$yandIni(this.$i18n.locale);
		this.baseLayers.addBaseLayer(this.$yndx, 'yandex');
		this.baseLayers.addTo(this.map);
    }
  },
  watch: {
    '$store.state.intLoc': function() {
        this.listLoc = this.$store.state.intLoc;
        //if(this.$yndx && this.map) this.$yndx._destroy(this.map);
        //if(!this.$yndx) this.$yandIni(this.$i18n.locale);
        //this.$yndx.onRemove(this.map);
        //this.$yandIni(this.listLoc);
        //this.key++;
        //this.defMaps();
        this.mount();
    }
  }
}
</script>

<style >
</style>